import React from "react";
import { object, number } from "prop-types";
import { format } from "date-fns";

import { Link } from "@quintype/components";
import Twitter from "../../icons/twitter";
import AuthorImage from "../../atoms/author-image";
import AuthorName from "../../atoms/author-name";
import "./author-details.m.css";

const AuthorDetails = ({ author, updatedOn }) => {
  const updatedDate = format(new Date(updatedOn), "d MMMM yyyy, hh:mm aaa");

  return (
    <div styleName="wrapper">
      {author["avatar-url"] && (
        <Link href={`/author/${author.id}`} styleName="author-image">
          <AuthorImage author={author} />
        </Link>
      )}
      <div>
        <div styleName="author-info">
          <Link href={`/author/${author.id}`}>
            <AuthorName author={author} fontSize="base" />
          </Link>
          {author["twitter-handle"] && (
            <div styleName="share-icon">
              <a
                href={`http://twitter.com/${author["twitter-handle"]}`}
                styleName="twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Twitter color="#bfbfbf" width={18} height={18} />
              </a>
            </div>
          )}
        </div>
        <div styleName="date-time">
          <span styleName="published-on">Updated on </span>
          <time styleName="date" dateTime={updatedDate}>
            : {updatedDate}
          </time>
        </div>
      </div>
    </div>
  );
};

AuthorDetails.propTypes = {
  author: object,
  updatedOn: number
};

export default AuthorDetails;
